import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { c } from 'ttag';
const UpgradeNow = ({ application, featuresController, subscriptionContoller }) => {
    const shouldShowCTA = !featuresController.hasFolders;
    const hasAccount = subscriptionContoller.hasAccount;
    const hasAccessToFeatures = subscriptionContoller.hasFirstPartyOnlineOrOfflineSubscription();
    const onClick = useCallback(() => {
        if (hasAccount && application.isNativeIOS()) {
            application.showPremiumModal();
        }
        else if (!application.canShowPurchaseFlow() && !hasAccount) {
            application.showAccountMenu();
        }
        else {
            void application.openPurchaseFlow();
        }
    }, [application, hasAccount]);
    if (!shouldShowCTA || hasAccessToFeatures) {
        return null;
    }
    if (!application.canShowPurchaseFlow() && hasAccount) {
        return null;
    }
    return (_jsx("div", { className: "flex h-full items-center px-2", children: _jsx("button", { className: "rounded bg-info px-1.5 py-0.5 text-sm font-bold uppercase text-info-contrast hover:brightness-125 lg:text-xs", onClick: onClick, children: !hasAccount
                ? c('B7.FilesSubscriptionHelp.Subscription.Info').t `Sign up to sync`
                : c('B7.FilesSubscriptionHelp.Subscription.Info').t `Unlock features` }) }));
};
export default observer(UpgradeNow);
